import React from "react";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useCreateGroupMutation } from "../../../services/groups";
import GroupForm from "../GroupForm";
import PermissionGate from "../../../CommonElements/PermissionGate";
import { permissions } from "@/utils/constants";

const CreateGroup = () => {
  const { t } = useTranslation();

  return (
    <Container fluid>
      <PageHeader
        title={t("ADD_NEW_GROUP")}

      />

        <GroupForm
          mutation={useCreateGroupMutation}
          submitButtonText={t("SAVE_GROUP")}
        />
    </Container>
  );
};

export default CreateGroup;
